import { takeLatest, call, put } from 'redux-saga/effects';
import { serializeParams } from 'utils/functions/general';
import laboratoriesActionTypes from './action-types';
import { getAllLabsWithFilters, addLab } from './api';
import {
  fetchAllLabsWithFiltersSuccess,
  fetchAllLabsWithFiltersFail,
  fetchAddLabSubmissionSuccess,
  fetchAddLabSubmissionFail,
} from './actions';

function* fetchAllLabsWithFiltersSaga({ payload }) {
  try {
    const queryStringOfObj = serializeParams(payload);
    const LabsResponse = yield call(getAllLabsWithFilters, queryStringOfObj);
    yield put(fetchAllLabsWithFiltersSuccess(LabsResponse.data));
  } catch (error) {
    yield put(fetchAllLabsWithFiltersFail(error));
  }
}

function* fetchAddLabSubmissionSaga({ payload }) {
  const { addLabPayload, callbackAction } = payload;
  try {
    const addLabSubmissionResponse = yield call(addLab, addLabPayload);
    callbackAction();
    yield put(fetchAddLabSubmissionSuccess(addLabSubmissionResponse));
  } catch (error) {
    yield put(fetchAddLabSubmissionFail(error));
  }
}

function* laboratoriesSagas() {
  yield takeLatest(
    laboratoriesActionTypes.FETCH_ALL_LABS_WITH_FILTERS,
    fetchAllLabsWithFiltersSaga,
  );
  yield takeLatest(laboratoriesActionTypes.FETCH_ADD_LAB_SUBMISSION, fetchAddLabSubmissionSaga);
}

export default laboratoriesSagas;
